module.exports = __webpack_public_path__ + "static/img/new_bussiness_img3.985d7af.png";